export default __webpack_public_path__ + "static/media/MoveIcon.4fd143b2.svg";